import React from 'react';
import { useTranslation } from 'react-i18next';
import { compose } from '@/utils/story-composer';
import LinkComponent from '@/components/elements/link-component';
import Image from '@/components/elements/image';

function NavigationItem({ elementProps, name, image, description, link, excludedLocales = [] }) {
	const { i18n } = useTranslation();
	const isExcludedLocale = excludedLocales.includes(i18n.language);

	if (isExcludedLocale) {
		return null;
	}

	return (
		<li {...elementProps} className="flex flex-row items-center">
			<LinkComponent
				link={link}
				appearance="w-full hover:bg-aqua-haze transition ease-in-out duration-150 px-7 py-3 flex"
			>
				<div className="mr-5 mt-1">
					<Image height="32" width="32" src={image.filename} alt={image.alt || ''} />
				</div>
				<div className="flex justify-center flex-col">
					<p className="font-semibold text-midnight">{name}</p>
					{description ?? <p className="mt-1/2 text-sm text-regent-gray">{description}</p>}
				</div>
			</LinkComponent>
		</li>
	);
}

export default NavigationItem;

compose('navigation-item', NavigationItem);
